const staticText = {
  title: 'Deleting user',
  body: (name, email) => `Are you sure you would like to remove ${name} (${email}) from this team?`,
  cancel: 'Cancel',
  delete: 'Delete',
  emailVerificationRequired: 'In order to delete your team member,',
};

export default staticText;
